import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { toast } from "sonner";
import { LIMA_LOGO } from "../components/LimaHeader";

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "" });

  const onLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Bem-vindo(a)!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha ao entrar");
    } finally { setLoading(false); }
  };

  const onRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Cadastro realizado!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha no cadastro");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left visual */}
      <div className="hidden lg:flex relative bg-[#10243f] text-white p-12 flex-col justify-between overflow-hidden">
        <div className="absolute inset-0"
             style={{
               backgroundImage: `linear-gradient(135deg, rgba(16,36,63,0.85), rgba(25,56,94,0.75)), url('https://images.unsplash.com/photo-1615990860014-99e51245218c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwc2FmZXR5JTIwbWV0YWxsdXJneSUyMHdvcmtlcnxlbnwwfHx8fDE3ODYyMzYzNTd8MA&ixlib=rb-4.1.0&q=85')`,
               backgroundSize: "cover",
               backgroundPosition: "center",
             }} />
        <div className="relative">
          <img src={LIMA_LOGO} alt="Lima SST" className="h-16 w-auto bg-white/95 rounded-md p-2" />
        </div>
        <div className="relative">
          <h2 className="font-display font-black text-4xl tracking-tighter leading-tight max-w-md">
            Onde a lei aperta, a Lima SST antecipa.
          </h2>
          <p className="mt-4 text-white/80 max-w-md">
            Motor adaptativo que ativa apenas as NRs pertinentes ao seu negócio e
            mostra, em minutos, sua real exposição a multas e autuações.
          </p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center px-6 py-16 bg-[#f4f6f8]">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden inline-block mb-6">
            <img src={LIMA_LOGO} alt="Lima SST" className="h-14 w-auto" />
          </Link>
          <span className="text-[11px] tracking-[0.28em] font-bold text-[#c7a45a]">ACESSO SEGURO</span>
          <h1 className="font-display font-black text-3xl tracking-tight text-[#10243f] mt-2 mb-8">
            Entrar na plataforma
          </h1>

          <Tabs defaultValue="login">
            <TabsList className="grid grid-cols-2 mb-6">
              <TabsTrigger value="login" data-testid="tab-login">Entrar</TabsTrigger>
              <TabsTrigger value="register" data-testid="tab-register">Criar conta</TabsTrigger>
            </TabsList>

            <TabsContent value="login">
              <form onSubmit={onLogin} className="space-y-4">
                <div>
                  <Label>Email</Label>
                  <Input required type="email" value={form.email} data-testid="login-email"
                    onChange={(e) => setForm({ ...form, email: e.target.value })} />
                </div>
                <div>
                  <Label>Senha</Label>
                  <Input required type="password" value={form.password} data-testid="login-password"
                    onChange={(e) => setForm({ ...form, password: e.target.value })} />
                </div>
                <Button disabled={loading} className="w-full bg-[#10243f] hover:bg-[#19385e] text-white h-11"
                  data-testid="login-submit">
                  {loading ? "Entrando..." : "Entrar"}
                </Button>
              </form>
            </TabsContent>

            <TabsContent value="register">
              <form onSubmit={onRegister} className="space-y-4">
                <div>
                  <Label>Nome</Label>
                  <Input required value={form.name} data-testid="register-name"
                    onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </div>
                <div>
                  <Label>Email</Label>
                  <Input required type="email" value={form.email} data-testid="register-email"
                    onChange={(e) => setForm({ ...form, email: e.target.value })} />
                </div>
                <div>
                  <Label>Senha</Label>
                  <Input required minLength={6} type="password" value={form.password} data-testid="register-password"
                    onChange={(e) => setForm({ ...form, password: e.target.value })} />
                </div>
                <Button disabled={loading} className="w-full bg-[#c7a45a] hover:bg-[#b58f43] text-[#10243f] font-bold h-11"
                  data-testid="register-submit">
                  {loading ? "Criando..." : "Criar conta"}
                </Button>
              </form>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
